export default __webpack_public_path__ + "static/media/expansion.fcd20843.svg";